export const AUTHORIZATION = 'Authorization'
export const AUTHORIZATION_ACCESS_TOKEN = 'Authorization-Access-Token'
export const AUTHORIZATION_REFRESH_TOKEN = 'Authorization-Refresh-Token'
export const HEADER_NAME = 'HeaderName'
export const X_XSRF_TOKEN = 'X-XSRF-TOKEN'
